import React, { useState } from "react";
import CustomModalLayout from "../../../../components/modal/CustomModalLayout";
import {
  address_icon,
  address_marker_icon,
  cap_icon,
  email_icon,
  phone_icon,
  website_icon,
} from "../../../../assets";
import { useIds } from "../../../../hook/AdminContext";
import { Tooltip } from "@mui/material";

function MoreDetails({ data, have_edit_access }) {
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <div className="primary-dot ms-3 me-2"></div>
      <span
        className="contact-info-button pointer"
        onClick={() => setOpen(true)}
      >
        Contact Info
      </span>
      <CustomModalLayout
        open={open}
        onClose={handleClose}
        title={data.company_name}
        componentToPass={<ContactInfo data={data} />}
      />
    </>
  );
}

export default MoreDetails;

const ContactInfo = ({ data }) => {
  console.log(data, "--data");
  const { userInfo } = useIds();
  return (
    <>
      <div className="">
        <div className="section-heading mb-3">Contact Information</div>
        {data.website_url && (
          <div className="mb-3">
            <img src={website_icon} alt="website_icon" />
            <span className="ps-2">{data.website_url}</span>
          </div>
        )}
        {/* <div className="mb-3">
          <img src={email_icon} alt="website_icon" />
          <span className="ps-2">{data.email}</span>
        </div> */}
        {data.contact_number && (
          <div className="mb-3">
            <img src={phone_icon} alt="website_icon" />
            <span className="ps-2">{data.contact_number}</span>
          </div>
        )}
        {data.location && (
          <div className="mb-3">
            <img src={address_icon} alt="website_icon" />
            <span className="ps-2">{data.location}</span>
          </div>
        )}
        {/*  */}

        {userInfo.role !== "candidate" &&
          data.direct_contact?.full_name &&
          data?.direct_contact_enabled && (
            <>
              <div className="section-heading mt-4 mb-3">
                Direct Contact Information
              </div>

              {data.direct_contact.full_name && (
                <div className="mb-3">
                  <img src={cap_icon} alt="website_icon" />
                  <Tooltip title="Full Name" arrow>
                    <span className="ps-2">
                      {data.direct_contact.full_name}
                    </span>
                  </Tooltip>
                </div>
              )}

              {data.direct_contact.company_email && (
                <div className="mb-3">
                  <img src={email_icon} alt="website_icon" />
                  <Tooltip title="Email" arrow>
                    <span className="ps-2">
                      {data.direct_contact.email_address}
                    </span>
                  </Tooltip>
                </div>
              )}
              {data.direct_contact.company_email && (
                <div className="mb-3">
                  <img src={email_icon} alt="website_icon" />
                  <Tooltip title="Company Email" arrow>
                    <span className="ps-2">
                      {data.direct_contact.company_email}
                    </span>
                  </Tooltip>
                </div>
              )}
              {data.direct_contact.phone_number && (
                <div className="mb-3">
                  <img src={phone_icon} alt="website_icon" />
                  <Tooltip title="Phone Number" arrow>
                    <span className="ps-2">
                      {data.direct_contact.phone_number}
                    </span>
                  </Tooltip>
                </div>
              )}
              {data.direct_contact.job_title && (
                <div className="mb-3">
                  <img src={cap_icon} alt="website_icon" />
                  <Tooltip title="Job Title" arrow>
                    <span className="ps-2">
                      {data.direct_contact.job_title}
                    </span>
                  </Tooltip>
                </div>
              )}
            </>
          )}
        {/*  */}
      </div>
    </>
  );
};
